(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beyond-food-diwali-page"] && !Shopify.designMode) return;
  try {
    
/* Beyond Food — Diwali Gift Builder section script.
   Supports multiple instances on the same page: each call to
   window.DiwaliGiftBuilder.init(sectionId, DATA) is fully scoped to
   that section's DOM ids (all suffixed with "-<sectionId>"). */
(function () {
  var SHAPES = {
    diamond: '<svg viewBox="0 0 24 24" fill="none" class="dgb-card-shape"><path d="M12 2L22 12L12 22L2 12L12 2Z" stroke="currentColor" stroke-width="1.4"/></svg>',
    diamond_filled: '<svg viewBox="0 0 24 24" fill="currentColor" class="dgb-card-shape"><path d="M12 2L22 12L12 22L2 12L12 2Z"/></svg>',
    circle: '<svg viewBox="0 0 24 24" fill="currentColor" class="dgb-card-shape"><circle cx="12" cy="12" r="10"/></svg>',
    star: '<svg viewBox="0 0 24 24" fill="currentColor" class="dgb-card-shape"><path d="M12 1l2.7 7.6L22 11l-7.3 2.4L12 21l-2.7-7.6L2 11l7.3-2.4L12 1z"/></svg>',
    bowl: '<svg viewBox="0 0 24 24" fill="none" class="dgb-card-shape"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.4"/><path d="M2 12h20" stroke="currentColor" stroke-width="1.4"/><path d="M2.5 12a9.5 9.5 0 0 0 19 0" fill="currentColor"/></svg>',
    pie: '<svg viewBox="0 0 24 24" fill="none" class="dgb-card-shape"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.4"/><path d="M12 12L12 2A10 10 0 0 1 19 5L12 12Z" fill="currentColor"/></svg>',
  };

  function escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function readData(root) {
    var dataEl = root.querySelector('.dgb-data-json');
    if (!dataEl) return null;
    try { return JSON.parse(dataEl.textContent); } catch (err) { return null; }
  }

  function init(sectionId) {
    var root = document.querySelector('[data-dgb-root="' + sectionId + '"]');
    if (!root) return;
    if (root.dataset.dgbInited === '1') return; // avoid double-init (e.g. theme editor re-render)
    var DATA = readData(root);
    if (!DATA) return;
    root.dataset.dgbInited = '1';

    function id(name) { return document.getElementById('dgb-' + name + '-' + sectionId); }

    var PRODUCTS = DATA.products || [];
    var COLLECTIONS = DATA.collections || [];
    var LOGOS = DATA.logos || [];
    var PROCESS_STEPS = DATA.steps || [];
    var TIERS = (DATA.tiers || []).slice().sort(function (a, b) { return a.min - b.min; }); // sorted ascending so getTier() always resolves the highest qualifying tier, regardless of block order in the theme editor
    var PACKAGING_FEE = DATA.packagingFee || 0;
    var CURRENCY = DATA.currency || '₹';
    var CATEGORY_ORDER = ['Bites', 'Barfi', 'Dry Fruits', 'Roasted Snacks', 'Laddu'];
    var CATEGORIES = ['All'];
    CATEGORY_ORDER.forEach(function (c) {
      if (CATEGORIES.indexOf(c) === -1 && PRODUCTS.some(function (p) { return p.cat === c; })) CATEGORIES.push(c);
    });
    PRODUCTS.forEach(function (p) { if (CATEGORIES.indexOf(p.cat) === -1) CATEGORIES.push(p.cat); });

    var state = { qty: {}, category: 'All', boxCount: DATA.defaultBoxQty || 500 };
    PRODUCTS.forEach(function (p) { state.qty[p.id] = p.defaultQty || 0; });

    function money(n) {
      return CURRENCY + Math.round(n).toLocaleString('en-IN');
    }

    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function addToCart(items) {
      return fetch(cartRoot.replace(/\/$/, '') + '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items }),
      }).then(function (res) {
        if (!res.ok) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            throw new Error(data.description || data.message || 'Could not add to cart. Please try again.');
          });
        }
        return res.json();
      });
    }

    function goToCartOrCheckout() {
      window.location.href = cartRoot.replace(/\/$/, '') + (DATA.cartRedirect === 'cart' ? '/cart' : '/checkout');
    }

    function getTier(boxCount) {
      var current = { min: 0, pct: 0 };
      for (var i = 0; i < TIERS.length; i++) if (boxCount >= TIERS[i].min) current = TIERS[i];
      var idx = TIERS.indexOf(current);
      var next = TIERS[idx + 1] || null;
      return { current: current, next: next };
    }

    function renderTiers() {
      var el = id('tiersList');
      if (!el) return;
      el.innerHTML = TIERS.map(function (t) {
        return '<div class="dgb-tier-item"><div class="dgb-pct">' + t.pct + '% OFF</div>' +
          '<div class="dgb-min">' + t.min.toLocaleString('en-IN') + '+ boxes</div></div>';
      }).join('');
    }

    function renderTabs() {
      var el = id('tabs');
      if (!el) return;
      el.innerHTML = CATEGORIES.map(function (c) {
        var count = c === 'All' ? PRODUCTS.length : PRODUCTS.filter(function (p) { return p.cat === c; }).length;
        return '<button type="button" class="dgb-tab-btn' + (c === state.category ? ' dgb-active' : '') + '" data-cat="' + escHtml(c) + '">' + escHtml(c) + ' (' + count + ')</button>';
      }).join('');
      el.querySelectorAll('.dgb-tab-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.category = btn.dataset.cat;
          renderTabs();
          renderProducts();
        });
      });
    }

    function cardMarkup(p) {
      var qty = state.qty[p.id];
      var selected = qty > 0;
      var shape = SHAPES[p.shape] || SHAPES.diamond;
      var actionHtml = selected
        ? '<div class="dgb-qty-stepper"><button type="button" data-action="minus" data-id="' + p.id + '">–</button>' +
          '<span class="dgb-qty-label"><b>' + qty + '</b> in each box</span>' +
          '<button type="button" data-action="plus" data-id="' + p.id + '">+</button></div>'
        : '<button type="button" class="dgb-add-btn" data-action="add" data-id="' + p.id + '">Add to box ' +
          '<svg width="13" height="13" viewBox="0 0 14 14" fill="none"><path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>';

      var topStyle = p.image
        ? 'background-image:url(\'' + p.image + '\');background-size:contain;background-repeat:no-repeat;background-position:center;'
        : 'background:linear-gradient(135deg, ' + p.color1 + ', ' + p.color2 + ');';

      return '' +
        '<div class="dgb-card' + (selected ? ' dgb-is-selected' : '') + (p.url ? ' dgb-card-clickable' : '') + '" data-id="' + p.id + '"' + (p.url ? ' data-url="' + escHtml(p.url) + '"' : '') + '>' +
        '<div class="dgb-card-top' + (p.image ? ' dgb-has-image' : '') + '" style="' + topStyle + '">' + (p.image ? '' : shape) +
        '<div class="dgb-card-check"><svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8.5l3 3 7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
        '<div class="dgb-card-tag">' + escHtml(p.badge || 'Clean label') + '</div>' +
        '</div>' +
        '<div class="dgb-card-body">' +
        '<div class="dgb-card-meta"><span class="dgb-card-cat">' + escHtml(p.cat) + '</span><span class="dgb-card-price">' + money(p.price) + '</span></div>' +
        '<div class="dgb-card-name">' + escHtml(p.name) + '</div>' +
        '<div class="dgb-card-desc">' + escHtml(p.desc) + '</div>' +
        (p.ingredients ? '<div class="dgb-card-ingredients" data-toggle="' + p.id + '">Ingredients &amp; details <span class="dgb-plus">+</span></div>' +
          '<div class="dgb-card-ingredients-panel" id="dgb-ing-' + p.id + '-' + sectionId + '">' + escHtml(p.ingredients) + '</div>' : '') +
        '<div class="dgb-card-action">' + actionHtml + '</div>' +
        '</div></div>';
    }

    function renderProducts() {
      var el = id('productGrid');
      if (!el) return;
      var list = state.category === 'All' ? PRODUCTS : PRODUCTS.filter(function (p) { return p.cat === state.category; });
      el.innerHTML = list.map(cardMarkup).join('');

      el.querySelectorAll('[data-action]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var pid = btn.dataset.id, action = btn.dataset.action;
          if (action === 'add') state.qty[pid] = 1;
          else if (action === 'plus') state.qty[pid]++;
          else if (action === 'minus') state.qty[pid] = Math.max(0, state.qty[pid] - 1);
          renderProducts();
          renderCart();
        });
      });

      el.querySelectorAll('[data-toggle]').forEach(function (row) {
        row.addEventListener('click', function () {
          var pid = row.dataset.toggle;
          row.classList.toggle('dgb-open');
          var panel = document.getElementById('dgb-ing-' + pid + '-' + sectionId);
          if (panel) panel.classList.toggle('dgb-open');
        });
      });

      if (!el.dataset.dgbClickBound) {
        el.dataset.dgbClickBound = '1';
        el.addEventListener('click', function (e) {
          if (e.target.closest('.dgb-card-action, .dgb-card-ingredients, .dgb-card-ingredients-panel')) return;
          var card = e.target.closest('.dgb-card[data-url]');
          if (card) {
            var url = card.getAttribute('data-url');
            if (url) window.open(url, '_blank', 'noopener');
          }
        });
      }
    }

    function renderCollections() {
      var el = id('collectionGrid');
      if (!el) return;
      el.innerHTML = COLLECTIONS.map(function (c) {
        var mediaStyle = c.image
          ? 'background-image:url(\'' + c.image + '\');background-size:contain;background-repeat:no-repeat;background-position:center;'
          : 'background:linear-gradient(135deg, ' + c.color1 + ', ' + c.color2 + ');';
        return '<div class="dgb-collection-card' + (c.url ? ' dgb-card-clickable' : '') + '"' + (c.url ? ' data-url="' + escHtml(c.url) + '"' : '') + '>' +
          '<div class="dgb-collection-media' + (c.image ? ' dgb-has-image' : '') + '" style="' + mediaStyle + '">' +
          '<div class="dgb-collection-num">' + escHtml(c.num) + '</div>' +
          (c.image ? '' : '<div class="dgb-mock-card"><b>' + escHtml(DATA.brandName || 'BRAND') + '</b><div class="dgb-rule"></div><span>' + escHtml(c.badgeLine || 'EDITION') + '</span></div>') +
          '<div class="dgb-collection-badge">' + escHtml(c.badge || 'Most loved') + '</div>' +
          '</div>' +
          '<div class="dgb-collection-info">' +
          '<div class="dgb-eyebrow">Curated corporate gift</div>' +
          '<h4>' + escHtml(c.title) + '</h4>' +
          '<span class="dgb-count">' + escHtml(c.count) + '</span>' +
          '<div class="dgb-collection-items">' + c.items.map(function (i) { return '<span>' + escHtml(i) + '</span>'; }).join('') + '</div>' +
          '<div class="dgb-collection-foot"><span class="dgb-collection-price">From ' + money(c.price) + '</span>' +
          '<div class="dgb-collection-actions">' +
          (c.variantId && DATA.enableCart
            ? '<button type="button" class="dgb-collection-cart-btn" data-cart-variant="' + escHtml(c.variantId) + '"' + (c.available ? '' : ' disabled') + '>' + (c.available ? 'Add to cart' : 'Sold out') + '</button>'
            : '') +
          '<a href="#dgb-contact-' + sectionId + '" class="dgb-collection-link">Enquire for this box →</a>' +
          '</div></div>' +
          '</div></div>';
      }).join('');

      el.querySelectorAll('[data-cart-variant]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var variantId = btn.dataset.cartVariant;
          var original = btn.textContent;
          btn.disabled = true;
          btn.classList.add('dgb-loading');
          btn.textContent = 'Adding…';
          addToCart([{ id: variantId, quantity: 1 }]).then(function () {
            goToCartOrCheckout();
          }).catch(function (err) {
            btn.disabled = false;
            btn.classList.remove('dgb-loading');
            btn.textContent = original;
            alert(err.message || 'Could not add this box to your cart.');
          });
        });
      });

      if (!el.dataset.dgbClickBound) {
        el.dataset.dgbClickBound = '1';
        el.addEventListener('click', function (e) {
          if (e.target.closest('a, button')) return;
          var card = e.target.closest('.dgb-collection-card[data-url]');
          if (card) {
            var url = card.getAttribute('data-url');
            if (url) window.open(url, '_blank', 'noopener');
          }
        });
      }
    }

    function renderLogos() {
      var el = id('logoGrid');
      if (!el) return;
      el.innerHTML = LOGOS.map(function (l) {
        return '<div class="dgb-logo-cell"><b style="color:' + (l.color || '#1c1f1b') + ';">' + escHtml(l.name) + '</b>' +
          (l.sub ? '<span>' + escHtml(l.sub) + '</span>' : '') + '</div>';
      }).join('');
    }

    function renderProcess() {
      var el = id('processGrid');
      if (!el) return;
      el.innerHTML = PROCESS_STEPS.map(function (s) {
        return '<div class="dgb-process-step"><div class="dgb-step-num">' + escHtml(s.num) + '</div>' +
          (s.icon || '') + '<h4>' + escHtml(s.title) + '</h4><p>' + escHtml(s.desc) + '</p></div>';
      }).join('');
    }

    function renderCart() {
      var selected = PRODUCTS.filter(function (p) { return state.qty[p.id] > 0; });
      var totalTreats = selected.reduce(function (s, p) { return s + state.qty[p.id]; }, 0);

      var linesHtml = selected.length
        ? selected.map(function (p) {
          return '<div class="dgb-cart-line"><div class="dgb-cart-line-info">' +
            '<div class="dgb-cart-swatch" style="background:linear-gradient(135deg, ' + p.color1 + ', ' + p.color2 + ');">' + (SHAPES[p.shape] || SHAPES.diamond) + '</div>' +
            '<div><div class="dgb-cart-line-name">' + escHtml(p.name) + '</div><div class="dgb-cart-line-sub">' + money(p.price) + ' × ' + state.qty[p.id] + '</div></div>' +
            '</div><div class="dgb-cart-line-price">' + money(p.price * state.qty[p.id]) + '</div></div>';
        }).join('')
        : '<div class="dgb-cart-empty">Add treats to build your box</div>';

      if (id('cartCount')) id('cartCount').textContent = totalTreats + (totalTreats === 1 ? ' treat' : ' treats') + ' selected';
      if (id('cartLines')) id('cartLines').innerHTML = linesHtml;
      if (id('cartFee')) id('cartFee').textContent = money(PACKAGING_FEE);

      var itemsTotal = selected.reduce(function (s, p) { return s + p.price * state.qty[p.id]; }, 0);
      var mrp = itemsTotal + PACKAGING_FEE;
      if (id('cartMrp')) id('cartMrp').textContent = money(mrp);

      var tier = getTier(state.boxCount);
      var current = tier.current, next = tier.next;
      // Packaging & handling is a flat per-box charge and should NOT be reduced by
      // the volume discount — only the treats themselves get the tier %. So the
      // packaging portion of the order value always equals PACKAGING_FEE * boxCount exactly.
      var discountedItemsPerBox = itemsTotal * (1 - current.pct / 100);
      var pricePerBox = discountedItemsPerBox + PACKAGING_FEE;
      var orderValue = pricePerBox * state.boxCount;

      if (id('pricePerBox')) id('pricePerBox').textContent = money(pricePerBox);
      if (id('discountPill')) id('discountPill').textContent = current.pct + '% OFF';
      if (id('orderValue')) id('orderValue').textContent = money(orderValue);

      var rangeNote = id('rangeNote');
      if (rangeNote) {
        rangeNote.innerHTML = next
          ? '<b>' + (next.min - state.boxCount).toLocaleString('en-IN') + '</b> boxes to go to unlock <b>' + next.pct + '% off</b>'
          : 'Maximum discount of <b>' + current.pct + '% off</b> unlocked';
      }

      var range = id('boxRange');
      if (range) {
        var min = +range.min, max = +range.max;
        var fillPct = Math.min(100, Math.max(0, ((state.boxCount - min) / (max - min)) * 100));
        range.style.setProperty('--fill', fillPct + '%');
      }

      if (id('stickyTop')) id('stickyTop').textContent = totalTreats + ' treats · ' + current.pct + '% off';
      if (id('stickyPrice')) id('stickyPrice').textContent = money(pricePerBox) + ' / box';
    }

    function setBoxCount(n) {
      if (!isFinite(n)) n = 0;
      n = Math.max(0, Math.min(50000, Math.round(n)));
      state.boxCount = n;
      if (id('boxQtyInput')) id('boxQtyInput').value = n;
      var range = id('boxRange');
      if (range) range.value = Math.min(+range.max, Math.max(+range.min, n));
      renderCart();
    }

    renderTiers();
    renderTabs();
    renderProducts();
    renderCollections();
    renderLogos();
    renderProcess();
    renderCart();

    if (id('boxMinus')) id('boxMinus').addEventListener('click', function () { setBoxCount(state.boxCount - 10); });
    if (id('boxPlus')) id('boxPlus').addEventListener('click', function () { setBoxCount(state.boxCount + 10); });
    if (id('boxQtyInput')) id('boxQtyInput').addEventListener('change', function (e) {
      var parsed = parseInt(String(e.target.value).replace(/[^\d]/g, ''), 10);
      setBoxCount(isNaN(parsed) ? 0 : parsed);
    });
    if (id('boxRange')) id('boxRange').addEventListener('input', function (e) { setBoxCount(+e.target.value); });

    if (id('mobileMenuBtn')) id('mobileMenuBtn').addEventListener('click', function () {
      id('mobileNav') && id('mobileNav').classList.toggle('dgb-open');
    });
    root.querySelectorAll('.dgb-mobile-nav a').forEach(function (a) {
      a.addEventListener('click', function () { id('mobileNav') && id('mobileNav').classList.remove('dgb-open'); });
    });

    if (id('enquireBtn')) id('enquireBtn').addEventListener('click', function () {
      var selected = PRODUCTS.filter(function (p) { return state.qty[p.id] > 0; });
      var summary = selected.map(function (p) { return p.name + ' x' + state.qty[p.id]; }).join(', ');
      var note = id('anythingElse');
      if (note && summary && !note.value) {
        note.value = 'Box selection: ' + summary + '. Quantity: ' + state.boxCount + ' boxes.';
      }
    });

    var placeOrderBtn = id('placeOrderBtn');
    if (placeOrderBtn) placeOrderBtn.addEventListener('click', function () {
      var msg = id('cartMsg');
      function setMsg(text, isError) {
        if (!msg) return;
        msg.textContent = text || '';
        msg.classList.toggle('dgb-cart-msg-error', !!isError);
      }

      if (state.boxCount <= 0) {
        setMsg('Set a box quantity greater than 0 before placing an order.', true);
        return;
      }

      var selected = PRODUCTS.filter(function (p) { return state.qty[p.id] > 0; });
      if (!selected.length) {
        setMsg('Add at least one treat to your box first.', true);
        return;
      }

      var skipped = [];
      var items = selected.reduce(function (arr, p) {
        if (!p.variantId) { skipped.push(p.name); return arr; }
        if (!p.available) { skipped.push(p.name + ' (sold out)'); return arr; }
        arr.push({ id: p.variantId, quantity: state.qty[p.id] * state.boxCount });
        return arr;
      }, []);

      if (!items.length) {
        setMsg("None of your selected treats are linked to a Shopify product yet — ask the store owner to link them, or use \"Enquire for this box\" instead.", true);
        return;
      }

      if (DATA.packagingFeeVariantId) {
        items.push({ id: DATA.packagingFeeVariantId, quantity: state.boxCount });
      }

      var originalText = placeOrderBtn.textContent;
      placeOrderBtn.disabled = true;
      placeOrderBtn.textContent = 'Adding to cart…';
      setMsg(skipped.length ? ("Note: " + skipped.join(', ') + " aren't linked to Shopify products and were left out of this order.") : '', false);

      addToCart(items).then(function () {
        goToCartOrCheckout();
      }).catch(function (err) {
        placeOrderBtn.disabled = false;
        placeOrderBtn.textContent = originalText;
        setMsg(err.message || 'Something went wrong adding this box to your cart.', true);
      });
    });
  }

  window.DiwaliGiftBuilder = { init: init };

  function drainQueue() {
    (window.DiwaliGiftBuilderQueue || []).forEach(function (sectionId) { init(sectionId); });
    // Any section rendered after this point (e.g. added later in the theme
    // editor) pushes into an array whose .push we've replaced, so it inits immediately.
    window.DiwaliGiftBuilderQueue = { push: function (sectionId) { init(sectionId); } };
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', drainQueue);
  } else {
    drainQueue();
  }

  // Re-init when the theme editor swaps this section's markup back in.
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-dgb-root]');
    if (r) {
      r.dataset.dgbInited = '';
      init(r.getAttribute('data-dgb-root'));
    }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-snack-planner"] && !Shopify.designMode) return;
  try {
    
  class BeyondFoodPlanner extends HTMLElement {
    connectedCallback() {
      this.step = 1;
      this.intro = this.querySelector('.bf-planner__intro');
      this.form = this.querySelector('.bf-planner__form');
      this.results = this.querySelector('.bf-planner__results');
      this.loading = this.querySelector('.bf-planner__loading');
      this.error = this.querySelector('.bf-planner__error');
      this.querySelector('.bf-planner__start').addEventListener('click', () => this.start());
      this.querySelector('.bf-planner__next').addEventListener('click', () => this.next());
      this.querySelector('.bf-planner__back').addEventListener('click', () => this.back());
      this.querySelector('.bf-planner__restart').addEventListener('click', () => this.restart());
      this.querySelector('.bf-planner__cart').addEventListener('click', () => this.addToCart());
      this.form.addEventListener('submit', (event) => this.submit(event));
    }
    start() { this.intro.hidden = true; this.form.hidden = false; this.renderStep(); }
    currentFieldset() { return this.querySelector(`[data-step="${this.step}"]`); }
    validStep() {
      const fields = [...this.currentFieldset().querySelectorAll('input')];
      const requiredNames = [...new Set(fields.filter((field) => field.required).map((field) => field.name))];
      const missing = requiredNames.some((name) => !fields.some((field) => field.name === name && field.checked));
      if (this.step === 3 && !fields.some((field) => field.checked)) return false;
      return !missing;
    }
    showError(message) { this.error.textContent = message; this.error.hidden = false; }
    next() {
      if (!this.validStep()) { this.showError(this.dataset.errorChoice); return; }
      this.error.hidden = true;
      if (this.step < 5) { this.step += 1; this.renderStep(); }
    }
    back() {
      this.error.hidden = true;
      if (this.step === 1) { this.form.hidden = true; this.intro.hidden = false; return; }
      this.step -= 1; this.renderStep();
    }
    renderStep() {
      this.querySelectorAll('.bf-planner__step').forEach((step) => { step.hidden = Number(step.dataset.step) !== this.step; });
      this.querySelector('.bf-planner__progress span').style.width = `${this.step * 20}%`;
      this.querySelector('.bf-planner__step-count').textContent = `${this.step} / 5`;
      this.querySelector('.bf-planner__next').hidden = this.step === 5;
      this.querySelector('.bf-planner__submit').hidden = this.step !== 5;
      this.currentFieldset().querySelector('input')?.focus();
    }
    answers() {
      const data = new FormData(this.form);
      return {
        ageBand: data.get('ageBand'), workStyle: data.get('workStyle'), goal: data.get('goal'),
        taste: data.get('taste'), priority: data.get('priority'), moments: data.getAll('moments'),
        snacksPerDay: Number(data.get('snacksPerDay')), durationDays: Number(data.get('durationDays'))
      };
    }
    submit(event) {
      event.preventDefault();
      if (!this.validStep()) { this.showError(this.dataset.errorSupply); return; }
      this.error.hidden = true; this.form.hidden = true; this.loading.hidden = false;
      try {
        this.plan = this.buildPlan(this.answers());
        window.setTimeout(() => this.renderResults(), 180);
      } catch (error) {
        this.loading.hidden = true; this.form.hidden = false; this.showError(error.message);
      }
    }
    catalog() {
      return [
        { key:'granola-honey-400', variantId:'52184734859448', title:'Granola – Honey Roasted', variantTitle:'400 gm', price:475, servings:12, moments:['breakfast'], tastes:['sweet','either'], goals:['balanced','weight_management','muscle_support'], priority:['convenience','protein','clean_ingredients'], ingredients:'40% oats and 40% nuts & seeds', facts:['14g protein per 100g','No processed flakes'], image:'https://cdn.shopify.com/s/files/1/0884/8205/4328/files/3_f102fd96-5a0b-40ca-b678-8586cead62bc.svg?v=1761042382' },
        { key:'protein-laddu-pista', variantId:'53980694511800', title:'Protein Laddu – Pista', variantTitle:'150g', price:299, servings:5, moments:['mid_morning','evening','after_dinner','post_workout'], tastes:['sweet','either'], goals:['balanced','weight_management','muscle_support'], priority:['protein','clean_ingredients','taste'], ingredients:'Pistachios, nuts, seeds and protein', facts:['5g protein per laddu','Made with familiar ingredients'], image:'https://cdn.shopify.com/s/files/1/0884/8205/4328/files/01_Product_Hero_8bb5f985-e75f-4db4-b928-53a69b9ea041.png?v=1787658343' },
        { key:'namkeen-peri-peri-200', variantId:'51684598415544', title:'Protein Wala Namkeen – Peri Peri', variantTitle:'200g', price:299, servings:5, moments:['mid_morning','evening'], tastes:['savoury','either'], goals:['balanced','weight_management','muscle_support'], priority:['protein','clean_ingredients','taste'], ingredients:'Nuts, seeds, grains and spices', facts:['6g protein per serving','100% roasted','Zero preservatives'], image:'https://cdn.shopify.com/s/files/1/0884/8205/4328/files/1_8afaadb9-2fb8-437a-a379-edac0d6a8a31.svg?v=1761029682' },
        { key:'energy-bar-assorted-6', variantId:'51679249432760', title:'Energy Bar – Assorted', variantTitle:'Pack of 6', price:300, servings:6, moments:['mid_morning','evening','post_workout'], tastes:['sweet','either'], goals:['balanced','muscle_support'], priority:['convenience','clean_ingredients'], ingredients:'Wholesome real-food ingredients', facts:['Portioned bars','No preservatives'], image:'https://cdn.shopify.com/s/files/1/0884/8205/4328/files/Untitled_design_6.svg?v=1761128414' }
      ];
    }
    productScore(product, answers, moment) {
      let score = product.moments.includes(moment) ? 10 : 0;
      if (product.tastes.includes(answers.taste)) score += 4;
      if (product.tastes.includes('either')) score += 1;
      if (product.goals.includes(answers.goal)) score += 4;
      if (product.priority.includes(answers.priority)) score += 3;
      if (answers.workStyle === 'field' && product.priority.includes('convenience')) score += 2;
      if (answers.workStyle === 'active' && product.goals.includes('muscle_support')) score += 2;
      return score;
    }
    planSummary(answers) {
      const routines = { desk:'desk-work routine', hybrid:'changing workday', field:'on-the-go workday', home:'work-from-home routine', active:'active routine' };
      const goals = { weight_management:'portion-aware choices', muscle_support:'protein-focused choices', balanced:'balanced everyday snacking' };
      return `A ${answers.durationDays}-day plan for your ${routines[answers.workStyle]}, built around ${goals[answers.goal]}.`;
    }
    itemReason(product, answers, moment, quantity, plannedOccasions) {
      const moments = { breakfast:'rushed mornings', mid_morning:'your mid-morning gap', evening:'4 PM hunger', post_workout:'your post-workout routine', after_dinner:'after-dinner sweet cravings' };
      const routines = { desk:'desk-work routine', hybrid:'changing workday', field:'on-the-go routine', home:'work-from-home routine', active:'active routine' };
      const packWord = quantity === 1 ? 'pack' : 'packs';
      return `Selected for ${moments[moment]} and your ${routines[answers.workStyle]}: ${product.facts[0].toLowerCase()}, with ${quantity} ${packWord} covering about ${plannedOccasions} planned servings.`;
    }
    buildPlan(answers) {
      const selectedMoments = answers.moments.slice(0, answers.snacksPerDay);
      if (!selectedMoments.length) throw new Error(this.dataset.errorPlan);
      const requiredOccasions = answers.durationDays * answers.snacksPerDay;
      const perMoment = Math.ceil(requiredOccasions / selectedMoments.length);
      const products = this.catalog();
      const items = selectedMoments.map((moment) => {
        const product = products.filter((candidate) => candidate.moments.includes(moment)).sort((a, b) => this.productScore(b, answers, moment) - this.productScore(a, answers, moment) || a.price - b.price)[0];
        if (!product) throw new Error(this.dataset.errorPlan);
        const quantity = Math.max(1, Math.ceil(perMoment / product.servings));
        const plannedOccasions = Math.min(perMoment, quantity * product.servings);
        return { ...product, moment, quantity, plannedOccasions, subtotal:product.price * quantity, reason:this.itemReason(product, answers, moment, quantity, plannedOccasions) };
      });
      return {
        durationDays:answers.durationDays,
        occasions:requiredOccasions,
        items,
        total:items.reduce((sum, item) => sum + item.subtotal, 0),
        summary:this.planSummary(answers),
        allergenNotice:'Most Beyond Food products contain nuts and/or are made in facilities handling nuts. Please check each product label before purchase and consumption.'
      };
    }
    renderResults() {
      const money = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });
      this.querySelector('.bf-planner__summary').textContent = this.plan.summary;
      this.querySelector('.bf-planner__items').innerHTML = this.plan.items.map((item) => `<article class="bf-planner__item"><img src="${this.escape(item.image)}" alt=""><div><small>${this.label(item.moment)}</small><h3>${this.escape(item.title)}</h3><p>${this.escape(item.reason)}</p><p><strong>${this.escape(this.dataset.ingredientsLabel)}:</strong> ${this.escape(item.ingredients)}</p></div><div class="bf-planner__qty">${item.quantity} × ${this.escape(item.variantTitle)}<br>${money.format(item.subtotal)}</div></article>`).join('');
      this.querySelector('.bf-planner__total strong').textContent = money.format(this.plan.total);
      this.querySelector('.bf-planner__notice').textContent = this.plan.allergenNotice;
      this.loading.hidden = true; this.results.hidden = false;
    }
    label(value) { return ({ breakfast:this.dataset.labelBreakfast, mid_morning:this.dataset.labelMidMorning, evening:this.dataset.labelEvening, post_workout:this.dataset.labelPostWorkout, after_dinner:this.dataset.labelAfterDinner })[value] || value; }
    escape(value) { const node = document.createElement('div'); node.textContent = String(value || ''); return node.innerHTML; }
    async addToCart() {
      const button = this.querySelector('.bf-planner__cart'); const status = this.querySelector('.bf-planner__cart-status');
      button.disabled = true; status.textContent = this.dataset.cartAdding;
      try {
        const response = await fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body:JSON.stringify({ items:this.plan.items.map((item) => ({ id:Number(item.variantId), quantity:item.quantity, properties:{ 'Snack moment':this.label(item.moment), 'Plan length':`${this.plan.durationDays} days` } })) }) });
        if (!response.ok) throw new Error(this.dataset.cartError);
        status.textContent = this.dataset.cartAdded; window.location.assign('/cart');
      } catch (error) { status.textContent = error.message; button.disabled = false; }
    }
    restart() { this.results.hidden = true; this.form.reset(); this.step = 1; this.intro.hidden = false; this.plan = null; }
  }
  if (!customElements.get('beyond-food-planner')) customElements.define('beyond-food-planner', BeyondFoodPlanner);

  } catch(e) { console.error(e); }
})();
})();
